import { useState } from 'react';

export default function Contact() {
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setSubmitting(true);
    const form = e.currentTarget;
    const data = new URLSearchParams();
    const formData = new FormData(form);
    formData.forEach((value, key) => {
      data.append(key, value as string);
    });
    try {
      await fetch('https://readdy.ai/api/form/d78vrkhrcamcd36dba0g', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: data.toString(),
      });
      setSubmitted(true);
    } catch {
      setSubmitted(true);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <section id="contact" className="w-full bg-white py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex flex-col lg:flex-row gap-16 lg:gap-24 items-start">
          {/* Left: CTA Text */}
          <div className="w-full lg:w-[42%] flex flex-col gap-6">
            <span className="inline-flex items-center border border-stone-400 text-stone-500 text-xs tracking-widest px-4 py-1.5 rounded-full w-fit">
              CONTACT
            </span>
            <h2 className="text-4xl md:text-5xl font-light text-stone-900 tracking-tight leading-tight">
              まずはお気軽に<br />ご相談ください。
            </h2>
            <p className="text-stone-500 text-sm leading-relaxed">
              法人のお客様の空間演出から、個人向けのオリジナルフレグランス開発まで、
              香りにまつわるご相談はお気軽にお問い合わせください。
            </p>
            <div className="w-full h-56 rounded-2xl overflow-hidden mt-2">
              <img
                src="https://public.readdy.ai/ai/img_res/ca05b395451a792915641e68dd23548e.jpg"
                alt="AMYMAISON Contact"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          {/* Right: Form */}
          <div className="w-full lg:w-[58%]">
            {submitted ? (
              <div className="flex flex-col items-center justify-center h-80 gap-4">
                <div className="w-14 h-14 flex items-center justify-center rounded-full bg-stone-100">
                  <i className="ri-check-line text-2xl text-stone-700" />
                </div>
                <p className="text-stone-700 text-base font-medium tracking-wide">お問い合わせを受け付けました</p>
                <p className="text-stone-400 text-sm">担当者よりご連絡いたします。しばらくお待ちください。</p>
              </div>
            ) : (
              <form
                data-readdy-form
                id="amymaison-contact-form"
                onSubmit={handleSubmit}
                className="flex flex-col gap-5"
              >
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                  <div className="flex flex-col gap-1.5">
                    <label className="text-xs tracking-widest text-stone-500">お名前 *</label>
                    <input
                      type="text"
                      name="name"
                      required
                      placeholder="山田 太郎"
                      className="border border-stone-200 rounded-lg px-4 py-3 text-sm text-stone-800 placeholder-stone-300 focus:outline-none focus:border-stone-400 bg-[#faf9f7]"
                    />
                  </div>
                  <div className="flex flex-col gap-1.5">
                    <label className="text-xs tracking-widest text-stone-500">会社名</label>
                    <input
                      type="text"
                      name="company"
                      placeholder="株式会社〇〇"
                      className="border border-stone-200 rounded-lg px-4 py-3 text-sm text-stone-800 placeholder-stone-300 focus:outline-none focus:border-stone-400 bg-[#faf9f7]"
                    />
                  </div>
                </div>
                <div className="flex flex-col gap-1.5">
                  <label className="text-xs tracking-widest text-stone-500">メールアドレス *</label>
                  <input
                    type="email"
                    name="email"
                    required
                    placeholder="example@email.com"
                    className="border border-stone-200 rounded-lg px-4 py-3 text-sm text-stone-800 placeholder-stone-300 focus:outline-none focus:border-stone-400 bg-[#faf9f7]"
                  />
                </div>
                <div className="flex flex-col gap-1.5">
                  <label className="text-xs tracking-widest text-stone-500">電話番号</label>
                  <input
                    type="tel"
                    name="phone"
                    placeholder="03-0000-0000"
                    className="border border-stone-200 rounded-lg px-4 py-3 text-sm text-stone-800 placeholder-stone-300 focus:outline-none focus:border-stone-400 bg-[#faf9f7]"
                  />
                </div>
                <div className="flex flex-col gap-1.5">
                  <label className="text-xs tracking-widest text-stone-500">お問い合わせ種別</label>
                  <select
                    name="inquiry_type"
                    className="border border-stone-200 rounded-lg px-4 py-3 text-sm text-stone-800 focus:outline-none focus:border-stone-400 bg-[#faf9f7] cursor-pointer"
                  >
                    <option value="">選択してください</option>
                    <option value="space">空間演出・法人向けサービス</option>
                    <option value="personal">個人向けフレグランス開発</option>
                    <option value="event">イベント・エンターテインメント</option>
                    <option value="wellness">ウェルネス・パーソナルケア</option>
                    <option value="other">その他</option>
                  </select>
                </div>
                <div className="flex flex-col gap-1.5">
                  <label className="text-xs tracking-widest text-stone-500">お問い合わせ内容 *</label>
                  <textarea
                    name="message"
                    required
                    rows={5}
                    maxLength={500}
                    placeholder="ご相談内容をご記入ください（500文字以内）"
                    className="border border-stone-200 rounded-lg px-4 py-3 text-sm text-stone-800 placeholder-stone-300 focus:outline-none focus:border-stone-400 bg-[#faf9f7] resize-none"
                  />
                </div>
                <button
                  type="submit"
                  disabled={submitting}
                  className="bg-stone-900 text-white text-xs tracking-widest px-8 py-4 rounded-full hover:bg-stone-700 transition-colors duration-300 cursor-pointer whitespace-nowrap disabled:opacity-50 mt-2"
                >
                  {submitting ? '送信中...' : 'お問い合わせ・ご相談はこちら（無料）'}
                </button>
              </form>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
